import { getApiUrl } from '../constants/api';
import axios from 'axios';

export const getSignedUrl = async (
  storeId: string,
  fileName: string,
  containerName: string,
) => {
  // Encode the file path for use in URL
  const encodedFileName = encodeURIComponent(fileName);

  const res = await axios.get(
    `${getApiUrl(
      `${storeId}`,
    )}/storage/signed-url/${encodedFileName}/${containerName}`,
  );

  const { url } = await res.data;
  return url || '';
};
